<template>
  <div class="totalBox">
    <div class="total1">
      <div class="box1">
        <img src="../../assets/product/bestImg1.png" class="imgIcon" alt="" />
        <p class="bestTitle">降低运营成本</p>
        <p class="bestContent">联网集中管理，降低客户运营成本。</p>
      </div>
    </div>
    <div class="total2">
      <div class="box2">
        <img src="../../assets/product/bestImg2.png" class="imgIcon" alt="" />
        <p class="bestTitle">优化车场管理</p>
        <p class="bestContent">车辆、设备、财务同步上云，实时监控停车场，实现车场的智能化运营管理。</p>
      </div>
    </div>
    <div class="total3">
      <div class="box3">
        <img src="../../assets/product/bestImg3.png" class="imgIcon" alt="" />
        <p class="bestTitle">适应各种场景</p>
        <p class="bestContent">封闭停车场、路边停车泊位均适用，轻松应对城市级停车管理需求。</p>
      </div>
    </div>
    <div class="total4">
      <div class="box4">
        <img src="../../assets/product/bestImg4.png" class="imgIcon" alt="" />
        <p class="bestTitle">提升车主体验</p>
        <p class="bestContent">不停车进出场，手机支付停车费，提高车主通行效率，减少收入流失。</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Bestmodel',
  data: function () {
    return {
      msg: 1
    }
  }
}
</script>

<style scoped>
#totalBox{
  width: 100%;
}

.total1,.total2,.total3,.total4{
  width: 100%;
}
.total1,.total3{
  background-color: RGBA(247, 247, 247, 1);
}
.total2,.total4{
  background-color: RGBA(255, 255, 255, 1)
}
.box1,.box2,.box3,.box4{
  width: 1200px;
  height: 460px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.box1{
  background-image: url(../../assets/product/best1.png);
}
.box2{
  background-image: url(../../assets/product/best2.png);
}
.box3{
  background-image: url(../../assets/product/best3.png);
}
.box4{
  background-image: url(../../assets/product/best4.png);
}
.imgIcon{
  width: 260px;
  height: 260px;
}
.bestTitle{
  font-size:40px;
  font-weight:bold;
  color:rgba(35,24,21,1);
  line-height:30px;
  margin-top: 39px;
}
.bestContent{
  margin-top: 15px;
  font-size:20px;
  font-weight:400;
  color:rgba(35,24,21,1);
  line-height:30px;
}
</style>



// WEBPACK FOOTER //
// src/components/productbest/bestModel.vue